import _get from 'lodash/get';
import { FormChecklistTemplateOption } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/checklistFieldNames';
import { getNewOptionValue } from '@lib/utils/formOptionsHelpers';

export const DEFAULT_VALUES: Values = {
  [FieldNames.Name]: '',
  [FieldNames.Description]: '',
  [FieldNames.DetailsTitle]: undefined,
  [FieldNames.OptionsTitle]: undefined,
  [FieldNames.Options]: [getNewOptionValue(0)],
};

export default function getDefaultValuesFromQueryData(data?: Values): Values {
  if (data?.id) {
    const options = _get(data, 'options', []) as FormChecklistTemplateOption[];
    return {
      ...DEFAULT_VALUES,
      [FieldNames.Name]: data?.name ?? '',
      [FieldNames.Description]: data?.description ?? '',
      [FieldNames.Options]: [...options]
        .sort((a, b) => a.position - b.position)
        .map(({ value, position, id }) => ({
          [FieldNames.OptionValues]: [value],
          position,
          id,
        })),
    };
  }
  return DEFAULT_VALUES;
}
